import * as client from '../../services/client';
import { TYPES, PATHS } from '../../common/constants';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { startFormLoading, stopFormLoading } from './loader';

export const setEmailTemplates = (payload) => ({
  type: TYPES.SET_EMAIL_TEMPLATES,
  payload,
});

export const setEmailTemplateForm = (payload) => ({
  type: TYPES.SET_EMAIL_TEMPLATE_FORM,
  payload,
});

export const clearEmailTemplates = () => ({
  type: TYPES.CLEAR_EMAIL_TEMPLATES,
});
export const clearEmailTemplateForm = () => ({
  type: TYPES.CLEAR_EMAIL_TEMPLATE_FORM,
});

export const fetchEmailTemplates = () => (dispatch) => {
  dispatch(startFormLoading());
  return client
    .fetchEmailTemplates()
    .then((response) => {
      if (response.ok || response.status === 200) {
        response.json().then((responsejson) => {
          dispatch(setEmailTemplates(responsejson));
          dispatch(stopFormLoading());
        });
      } else {
        dispatch(stopFormLoading());
      }
    })
    .catch(() => {
      dispatch(stopFormLoading());
    });
};

export const updateEmailTemplate = (data) => (dispatch) => {
  dispatch(startFormLoading());
  return client.updateEmailTemplate(data).then((response) => {
    if (response.status === 200 || response.ok) {
      response.json().then((responsejson) => {
        dispatch(fetchEmailTemplates());
        dispatch(stopFormLoading());
        toast.success(' ⓘ Email Templates has been updated.', {
          autoClose: 10000,
          position: 'top-center',
        });
      });
    } else {
      dispatch(stopFormLoading());
      toast.error(
        ' 🚫 Something went wrong with updating of Email Templates, please try again. ',
        { autoClose: 12000, position: 'top-center' }
      );
    }
  });
};
